import React from "react";
import PropTypes from "prop-types";
import { TRIAL_ATTENDANCE_STATUS } from "../../../../constants/enrollments";
import { resolveTrialAttendance } from "../helpers";

/**
 * TrialsStats
 * Painel bespoke de indicadores integrados de Aulas Experimentais.
 * Apresenta métricas chave consolidadas em uma única barra outonal glassmorphic.
 */
const TrialsStats = ({ trials = [] }) => {
    const total = trials.length;
    const attended = trials.filter((t) => resolveTrialAttendance(t) === TRIAL_ATTENDANCE_STATUS.PRESENT).length;
    const noShow = trials.filter((t) => resolveTrialAttendance(t) === TRIAL_ATTENDANCE_STATUS.ABSENT).length;
    const converted = trials.filter((t) => t.convertedToSale === true).length;

    const totalPast = trials.filter((t) => new Date(t.sessionDate) < new Date()).length;
    const future = trials.filter((t) => new Date(t.sessionDate) >= new Date()).length;

    // Taxa de conversão: convertidos / total de experimentais passadas
    const conversionRate = totalPast > 0 ? Math.round((converted / totalPast) * 100) : 0;

    return (
        <div className="neo-stats-bar">
            <div className="row g-0 align-items-center">
                {/* Total Agendado */}
                <div className="col-12 col-md-3 neo-stats-bar-col">
                    <div className="d-flex align-items-center">
                        <div className="neo-stats-bar-icon-bg bg-primary-soft">
                            <i className="mdi mdi-calendar-clock"></i>
                        </div>
                        <div className="ms-3">
                            <span className="neo-stats-bar-label">Total Agendado</span>
                            <h4 className="neo-stats-bar-value">{total}</h4>
                            <span className="neo-stats-bar-subtext">{future} previstas</span>
                        </div>
                    </div>
                </div>

                {/* Comparecimento */}
                <div className="col-12 col-md-3 neo-stats-bar-col border-start-md">
                    <div className="d-flex align-items-center">
                        <div className="neo-stats-bar-icon-bg bg-success-soft">
                            <i className="mdi mdi-check-circle-outline"></i>
                        </div>
                        <div className="ms-3">
                            <span className="neo-stats-bar-label">Comparecimento</span>
                            <h4 className="neo-stats-bar-value">{attended}</h4>
                            <span className="neo-stats-bar-subtext">
                                {totalPast > 0 ? `${Math.round((attended / totalPast) * 100)}%` : "0%"} das passadas
                            </span>
                        </div>
                    </div>
                </div>

                {/* No-Show (Faltas) */}
                <div className="col-12 col-md-3 neo-stats-bar-col border-start-md">
                    <div className="d-flex align-items-center">
                        <div className="neo-stats-bar-icon-bg bg-danger-soft">
                            <i className="mdi mdi-close-circle-outline"></i>
                        </div>
                        <div className="ms-3">
                            <span className="neo-stats-bar-label">No-Show (Faltas)</span>
                            <h4 className="neo-stats-bar-value">{noShow}</h4>
                            <span className="neo-stats-bar-subtext">
                                {totalPast > 0 ? `${Math.round((noShow / totalPast) * 100)}%` : "0%"} das passadas
                            </span>
                        </div>
                    </div>
                </div>

                {/* Taxa de Conversão - HERO */}
                <div className="col-12 col-md-3 neo-stats-bar-col border-start-md">
                    <div className="d-flex align-items-center">
                        <div className="neo-stats-bar-icon-bg bg-warning-soft">
                            <i className="mdi mdi-trophy-outline"></i>
                        </div>
                        <div className="ms-3">
                            <span className="neo-stats-bar-label">Taxa de Conversão</span>
                            <h4 className="neo-stats-bar-value text-accent">{conversionRate}%</h4>
                            <span className="neo-stats-bar-subtext">
                                {converted} de {totalPast} convertidos
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

TrialsStats.propTypes = {
    trials: PropTypes.array.isRequired
};

export default TrialsStats;
